import { get, post } from '../../../DAL/data-provider';


export const getSasUrl = async (presetGuid: string) => {

    return get('/api/audiobase64/get-sas-url', {
        presetGuid,
    });
};

export const getBase64String = async (sasUrl: string) => {

    return get(sasUrl);
};